// src/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit"
import broadcastReducer from "@/features/broadcast/broadcastSlice"
import patientReducer from "@/features/patient/patientSlice"
import insuranceReducer from "@/features/insurance/insuranceSlice"
import memberReducer from "@/features/member/memberSlice"
import renderControlReducer from "@/features/renderControl/renderControlSlice"
import layerControlReducer from "@/features/layercontrol/layerControlSlice"
import encounterReducer from "@/features/encounter/encounterSlice"
import encounterItemReducer from "@/features/encounter/encounterItemSlice"
import encounterHistoryReducer from "@/features/encounter/encounterHistorySlice"
import clickInfoReducer from "@/features/clickinfo/clickinfoSlice"
import doctorReducer from "@/features/doctor/doctorSlice"
import departmentReducer from "@/features/department/departmentSlice"
import sugaReducer from "@/features/suga/sugaSlice"
import buhangcupReducer from "@/features/suga/buhangcupSlice"
import pharmaReducer from "@/features/pharma/pharmaComplexSlice"
import pharmaSimpleReducer from "@/features/pharma/pharmaISimpleSlice"
import pharmacyReducer from "@/features/pharmacy/pharmacySlice"
import hospitalReducer from "@/features/hospital/hospitalSlice"
import visitSelectionReducer from "@/features/visit/visitSelectionSlice"
import selectedVisitReducer from "@/features/selectedVisit/selectedVisitSlice"
import reservationReducer from "@/features/reservation/reservationSlice"
import uninsuredItemReducer from "@/features/uninsured/uninsuredItemSlice"
import uninsuredCategoryReducer from "@/features/uninsured/uninsuredCategorySlice"
import visitrouteReducer from "@/features/visitroute/visitrouteSlice"
import copiedClipboardReducer from "@/features/clipboard/copiedClipboardSlice"
import selectedDateReducer from "@/features/selectedDate/selectedDateSlice"
import hospitalSettingReducer from "@/features/hospitalSetting/hospitalSettingSlice"
import hospitalFavoriteReducer from "@/features/hospitalFavorite/hospitalFavoriteSlice"
import chunaPendingReducer from "@/features/hira/chunaPendingSlice"
import herbalPendingReducer from "@/features/hira/herbalPendingSlice"
import nhisChupyakPendingReducer from "@/features/hira/nhisChupyakPendingSlice"
import stampReducer from "@/features/stamp/stampSlice"
import availabilityReducer from "@/features/availability/availabilitySlice"
import dashboardPanelSortReducer from "@/features/dashboardPanelSort/dashboardPanelSortSlice"
import holidayCalendarReducer from "@/features/holidayCalendar/holidayCalendarSlice"

import {
  // reservationVisit,
  waitingVisit,
  treatmentVisit,
  completeVisit,
} from "@/features/visit/visitSlice"

const rootReducer = combineReducers({
  // reservationVisit: reservationVisit.reducer,
  waitingVisit: waitingVisit.reducer,
  treatmentVisit: treatmentVisit.reducer,
  completeVisit: completeVisit.reducer,
  selectedVisit: selectedVisitReducer,
  hospital: hospitalReducer,
  broadcast: broadcastReducer,
  member: memberReducer,
  patient: patientReducer,
  insurance: insuranceReducer,
  renderControl: renderControlReducer,
  layerControl: layerControlReducer, // Added layerControl property
  encounter: encounterReducer,
  encounterItem: encounterItemReducer,
  encounterHistory: encounterHistoryReducer,
  clickinfo: clickInfoReducer,
  doctor: doctorReducer,
  department: departmentReducer,
  suga: sugaReducer,
  buhangcup: buhangcupReducer,
  pharma: pharmaReducer,
  pharmaSimple: pharmaSimpleReducer,
  pharmacy: pharmacyReducer,
  visitSelection: visitSelectionReducer,
  reservation: reservationReducer,
  visitroute: visitrouteReducer,
  uninsuredItem: uninsuredItemReducer,
  uninsuredCategory: uninsuredCategoryReducer,
  copiedClipboard: copiedClipboardReducer,
  selectedDate: selectedDateReducer,
  hospitalSetting: hospitalSettingReducer,
  hospitalFavorite: hospitalFavoriteReducer,
  chunaPending: chunaPendingReducer,
  herbalPending: herbalPendingReducer,
  nhisChupyakPending: nhisChupyakPendingReducer,
  stamp: stampReducer,
  availability: availabilityReducer,
  dashboardPanelSort: dashboardPanelSortReducer,
  holidayCalendar: holidayCalendarReducer,
})

const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store

